/**
 * iOS Safari 호환 MediaRecorder 유틸리티
 * iOS Safari는 audio/webm을 지원하지 않으므로 지원되는 MIME 타입을 자동 감지
 */

/**
 * 지원되는 오디오 MIME 타입 찾기
 * iOS Safari는 audio/mp4 또는 audio/aac를 지원
 */
export function getSupportedAudioMimeType(): string {
  if (typeof MediaRecorder === "undefined") {
    return "audio/webm"; // 기본값 (MediaRecorder가 없으면 fallback)
  }

  // iOS Safari 감지
  const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
  const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

  // 지원 가능한 MIME 타입 순서대로 시도
  const mimeTypes = [
    "audio/webm;codecs=opus", // Chrome/Firefox
    "audio/webm", // 일반적인 WebM
    "audio/mp4", // iOS Safari
    "audio/aac", // iOS Safari 대체
    "audio/mp3", // 폴백
  ];

  // iOS Safari인 경우 mp4 우선
  if (isIOS && isSafari) {
    const iosTypes = ["audio/mp4", "audio/aac", "audio/mp3"];
    for (const type of iosTypes) {
      if (MediaRecorder.isTypeSupported(type)) {
        console.log(`✅ iOS Safari 지원 MIME 타입: ${type}`);
        return type;
      }
    }
  }

  // 일반 브라우저용
  for (const type of mimeTypes) {
    if (MediaRecorder.isTypeSupported(type)) {
      console.log(`✅ 지원되는 MIME 타입: ${type}`);
      return type;
    }
  }

  // 기본값 (MediaRecorder가 자동으로 선택)
  console.warn("⚠️ 지원되는 MIME 타입을 찾을 수 없습니다. 기본값 사용");
  return "";
}

/**
 * MIME 타입에 따른 파일 확장자 반환
 */
export function getFileExtensionFromMimeType(mimeType: string): string {
  if (mimeType.includes("mp4") || mimeType.includes("aac")) {
    return "m4a";
  }
  if (mimeType.includes("webm")) {
    return "webm";
  }
  if (mimeType.includes("mp3")) {
    return "mp3";
  }
  return "webm"; // 기본값
}

/**
 * iOS Safari 호환 MediaRecorder 생성
 */
export function createIOSCompatibleMediaRecorder(
  stream: MediaStream
): MediaRecorder {
  const mimeType = getSupportedAudioMimeType();

  if (mimeType) {
    try {
      const recorder = new MediaRecorder(stream, { mimeType });
      console.log(`✅ MediaRecorder 생성 성공: ${recorder.mimeType}`);
      return recorder;
    } catch (error) {
      console.warn("⚠️ 지정된 MIME 타입으로 생성 실패, 기본값 사용:", error);
    }
  }

  // 기본 생성자 사용 (브라우저가 자동 선택)
  return new MediaRecorder(stream);
}





